export default {
  sliders: [
    {
      name: 'short_description',
      type: 'string'
    }
  ]
}
